import MUIIconButton, { IconButtonProps as MUIIconButtonProps } from '@mui/material/IconButton';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import styles from './styles';

const useStyles = makeStyles(styles);

interface IIconButtonPros extends MUIIconButtonProps {
  className?: string;
}

const IconButton: React.FC<IIconButtonPros> = (props) => {
  const classes = useStyles();
  const classProps = clsx(props.className, classes.IconButton);

  return (
    <MUIIconButton data-testid="of-icon-button" {...props} className={classProps}>
      {props.children}
    </MUIIconButton>
  );
};

export default IconButton;
